module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/placeholder/placeholder.component.scss
// module id = ./src/app/components/placeholder/placeholder.component.scss
// module chunks = main